import type { JSONContent } from '@tiptap/core'
import type { ColorPaletteOption, PaletteColor } from '@/components/shared/color/types'
import type TaskStage from '@/data/models/domain/tasks/TaskStage'
import type TaskBoard from '@/data/models/domain/tasks/TaskBoard'
import type { PriorityEnum } from '@/data/models/domain/types'
import type { Emoji } from '@/services/forms/tmTiptap/types'
import type { SelectContactFieldConfig } from '@/services/forms/types'
import type { RegisteredServices } from '@/core/container/types'

export const createTaskBoardFormId = 'TaskBoardFormService'
export const createTaskStageFormId = 'TaskStageFormService'
export const editTaskStageFormId = 'TaskEditStageFormService'
export const moveAllTaskFormId = 'TaskMoveAllFormService'
export const taskViewFormId = 'TaskViewFormService'
export const createTaskForStageFormId = 'FastCreateTaskFormService'

export const nameField = 'name'
export const colorField = 'color'
export const descriptionField = 'description'

export const colorOptions: ColorPaletteOption[] = [
  {
    color: 'orange',
    outline: true,
  },
  {
    color: 'blue',
    outline: true,
  },
  {
    color: 'green',
    outline: true,
  },
  {
    color: 'red',
    outline: true,
  },
  {
    color: 'cyan',
    outline: true,
  },
  {
    color: 'violet',
    outline: true,
  },
  {
    color: 'purpur',
    outline: true,
  },
  {
    color: 'brown',
    outline: true,
  },
]

export type CreateTaskStageFormSchema = {
  [nameField]: string
  [colorField]: PaletteColor
}

export type TaskBoardFormSchema = {
  [nameField]: {
    text: string
    emoji: Partial<Emoji>
  }
  [descriptionField]?: string
}

export enum CreateTaskFormFieldNames {
  title = 'title',
  description = 'description',
  stage = 'stage',
  boardId = 'boardId',
  priority = 'priority',
  dueDate = 'dueDate',
  assigneeId = 'assigneeId',
  contactId = 'contactId',
  chatId = 'chatId',
}

export type CreateTaskFormScheme = {
  [CreateTaskFormFieldNames.title]: string
  [CreateTaskFormFieldNames.description]: JSONContent
  [CreateTaskFormFieldNames.boardId]: TaskBoard['id']
  [CreateTaskFormFieldNames.stage]: TaskStage['id']
  [CreateTaskFormFieldNames.priority]: PriorityEnum
  [CreateTaskFormFieldNames.assigneeId]: string
  [CreateTaskFormFieldNames.contactId]: SelectContactFieldConfig['value']
  [CreateTaskFormFieldNames.dueDate]: string | null
  [CreateTaskFormFieldNames.chatId]: string
}

export type FastCreateTaskFormScheme = {
  [CreateTaskFormFieldNames.title]: string
}

export type CreateTaskParamsPartial = {
  //
}

export enum TaskViewFormFieldNames {
  title = 'title',
  description = 'description',
  stage = 'stage',
  priority = 'priority',
  assigneeId = 'assigneeId',
  contactId = 'contactId',
  dueDate = 'dueDate',
}

export type TaskViewFormScheme = {
  [CreateTaskFormFieldNames.title]: string
  [CreateTaskFormFieldNames.description]?: JSONContent
  [CreateTaskFormFieldNames.stage]: TaskStage['id']
  [CreateTaskFormFieldNames.priority]: PriorityEnum
  [CreateTaskFormFieldNames.assigneeId]: string
  [CreateTaskFormFieldNames.contactId]: SelectContactFieldConfig['value']
  [CreateTaskFormFieldNames.dueDate]?: string | null
}

export type TaskViewParamsPartial = {
  //
}

export enum TaskMoveAllFormFieldNames {
  stage = 'stage',
}

export type TaskMoveAllFormScheme = {
  [CreateTaskFormFieldNames.stage]: TaskStage['id']
}

export type TaskMoveAllParamsPartial = {
  //
}

export enum TaskStageDeleteApproach {
  delete = 'delete',
  moveAll = 'moveALl',
}

export enum TaskStageDeleteFormFieldNames {
  approach = 'approach',
  stage = 'stage',
}

export type TaskStageDeleteFormScheme = {
  [TaskStageDeleteFormFieldNames.approach]: TaskStageDeleteApproach
  [TaskStageDeleteFormFieldNames.stage]: string
}

export const TASKS_LIST_ID = 'tasksListId' as RegisteredServices
export const TASKS_PER_PAGE: number = 999
